module.exports = __webpack_public_path__ + "img/sedan_stopped.6b675d53.svg";